/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SVGIcon from '@ba-ui-toolkit/svgicon';
import ToolTip from '@ba-ui-toolkit/tooltip';
import Button from '@ba-ui-toolkit/button';

import infoIcon from '@ba-ui-toolkit/ba-graphics/dist/icons-js/information_16.js';
import closeIcon from '@ba-ui-toolkit/ba-graphics/dist/icons-js/close_16.js';
import defaultStyles from './GlobalBanner.scss';
import stringResource from './nls/StringResource';

const globalBannerClassName = defaultStyles.globalBannerClassName.replace(/"/g, '');

export class GlobalBanner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: true,
		};
	}

	static propTypes = {
		children: PropTypes.node,
		statusText: PropTypes.string,
		displayString: PropTypes.string,
		onClose: PropTypes.func,
		closeText: PropTypes.string,
		className: PropTypes.string,
		style: PropTypes.object,
	};

	static defaultProps = {
		closeText: stringResource.get('closeText'),
	};

	_onClose = e => {
		const { onClose } = this.props;
		onClose && onClose(e);
		this.setState({
			isVisible: false,
		});
	};

	render() {
		const { statusText, displayString, closeText, className, style, children } = this.props;
		if (this.state.isVisible) {
			return (
				<div className={`${globalBannerClassName}`} style={style}>
					<div className={`${globalBannerClassName}__modal`}>
						<ToolTip
							className={`${globalBannerClassName}__statusIcon`}
							title={statusText}
							data-tid="ba-common-global_banner__statusTooltip"
						>
							<SVGIcon
								data-tid="ba-common-global_banner__statusIcon"
								aria-label={stringResource.get('information')}
								className={className}
								size="small"
								focusable={false}
								iconId={infoIcon.id}
							/>
						</ToolTip>
						<div
							className={`${globalBannerClassName}__content`}
							data-tid="ba-common-global_banner__content"
						>
							{displayString || children}
						</div>
						<ToolTip
							className={`${globalBannerClassName}__closeX`}
							orient="bottom"
							title={closeText}
						>
							<Button
								data-tid="ba-common-global-banner__closeX"
								icon={closeIcon.id}
								onClick={this._onClose}
								onTouchEnd={this._onClose}
								variant="icon"
								intent="primary"
								iconSize="small"
								aria-label={stringResource.get('dismiss')}
							/>
						</ToolTip>
					</div>
				</div>
			);
		}

		return null;
	}
}
